import {
  UPDATE_TEAM_REQUEST,
  UPDATE_TEAM_SUCCESS,
  CHANGE_TEAM_NAME,
  UPDATE_TEAM_ERROR,
  CHANGE_TEAM_PICTURE,
  CREATE_TEAM_CONVERSATION_REQUEST,
  CREATE_TEAM_CONVERSATION_SUCCESS,
  CREATE_TEAM_CONVERSATION_ERROR,
} from "./constants";
import { LOGOUT } from "../login/constants";
import { ITeamReducer } from "./types";

const initialState: ITeamReducer = {
  requesting: false,
  successful: false,
  errors: {
    name: "",
    email: "",
    password: "",
  },
  name: "",
  pictureData: {
    name: "",
    uri: "",
    picture: "",
  },
  conversationId: "",
  conversationRequesting: false,

};

const reducer = function actionReducer(
  state: ITeamReducer = initialState,
  action,
): ITeamReducer {
  switch (action.type) {
    case UPDATE_TEAM_REQUEST: {
      return {
        ...state,
        requesting: true,
      };
    }
    case UPDATE_TEAM_SUCCESS:
      return {
        ...state,
        requesting: false,
        name: action.payload.name,
        pictureData: initialState.pictureData,
      };

    case UPDATE_TEAM_ERROR:
      return {
        ...state,
        requesting: false,
      };

    case CHANGE_TEAM_NAME:
      return {
        ...state,
        name: action.payload,
      };

    case CHANGE_TEAM_PICTURE:
      return {
        ...state,
        pictureData: action.payload,
      };

    case CREATE_TEAM_CONVERSATION_REQUEST:
      return {
        ...state,
        conversationRequesting: true,
      };

    case CREATE_TEAM_CONVERSATION_SUCCESS:
      return {
        ...state,
        conversationId: action.payload.conversationId,
        conversationRequesting: false,
      };

    case CREATE_TEAM_CONVERSATION_ERROR:
      return {
        ...state,
        conversationRequesting: false,
      };
    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
